import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson1DefaultStartCode = `%lang starknet

// Resource
// https://www.cairo-lang.org/docs/how_cairo_works/cairo_intro.html#registers
// https://www.cairo-lang.org/docs/how_cairo_works/functions.html#function-arguments-and-return-values
${doNotModifyCodeAbove}`;

export const lesson1DefaultMiddleCode = `// Rewrite this function with a high level syntax
@external
func assert_is_42(n : felt) {
    // [ap - 3] = 42
    // ret
}

// Rewrite this function with a low level syntax, using registers
@external
func sum(a : felt, b : felt) -> (s : felt) {
    // return (a + b)
}`;

export const lesson1DefaultEndCode = `${doNotModifyCodeBelow}
@external
func test_assert_is_42_ok() {
    assert_is_42(42);
    return ();
}

@external
func test_assert_is_42_ko() {
    %{ expect_revert() %}
    assert_is_42(21);
    return ();
}

@external
func test_sum() {
    let (s) = sum(2, 3);
    assert s = 5;
    return ();
}`;
